import React, { createContext, useContext, useCallback, useState, useMemo } from 'react';

const ToastContext = createContext(null);

let idCounter = 1;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, { type = 'info', timeout = 4000 } = {}) => {
    const id = idCounter++;
    setToasts((t) => [...t, { id, message, type }]);
    if (timeout > 0) {
      setTimeout(() => {
        setToasts((t) => t.filter((x) => x.id !== id));
      }, timeout);
    }
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((t) => t.filter((x) => x.id !== id));
  }, []);

  const value = useMemo(() => ({
    add: addToast,
    success: (m, opts) => addToast(m, { ...opts, type: 'success' }),
    error: (m, opts) => addToast(m, { ...opts, type: 'error' }),
    info: (m, opts) => addToast(m, { ...opts, type: 'info' }),
    remove: removeToast,
  }), [addToast, removeToast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="toasts" aria-live="polite">
        {toasts.map((t) => (
          <div key={t.id} className={`toast ${t.type}`} role={t.type === 'error' ? 'alert' : 'status'}>
            <div style={{flex:1}}>{t.message}</div>
            <button aria-label="Fermer" onClick={() => removeToast(t.id)} className="btn btn-ghost" style={{marginLeft:8}}>×</button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast(){
  const ctx = useContext(ToastContext);
  if(!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}

export default ToastContext;
